<template>
    <div class="step">
        <div class="step__container">

            <!-- Title -->
            <div class="step__title" ref="title">
                <p>Your mobile phone number</p>
            </div>

            <!-- Subtitle -->
            <div class="step__subtitle" ref="subtitle">
                <!-- <p>{{step.subtitle}}</p> -->
                <p>You will be added as their first contact</p>
            </div>

            <!-- Form -->
            <div class="step__form" ref="form">

                <InputField
                    title="MOBILE NUMBER"
                    type="tel"
                    placeholder="(123) 456-7890"
                    autocomplete="mobile tel"
                    v-model="phoneNumber"
                    :disabled="false"
                    :errored="false"
                    :validated="numberValid"
                    errorMessage=""
                    mask="(###) ###-####"
                ></InputField>
                <!-- v-mask="'(###) ###-####'" -->

<!-- 
                <div class="input">
                    <form>
                        <label class="input__label" for="tel">mobile number</label>
                        <div class="input__block" :class="{ 'input__block--check': isNumberValid() }">

                        </div>
                    </form>
                </div> -->
            </div>

            <!-- Next Button -->
            <div class="step__button step__button--bottom" ref="button">
                <a href="#" @click.prevent="goNextStep" class="button" :class="{ 'button--disable': !this.numberValid }">
                    <span>Next</span>
                </a>
            </div>

        </div>
    </div>
</template>

<script>

    import checkWhiteIcon from '@/assets/svg/check-white.svg';
    import InputField from "@/components/1-common/InputField";
    import { TimelineMax } from 'gsap';
    import { contactsCollection, auth, usersCollection } from '../../tools/firebaseConfig';

    let tl = new TimelineMax({
        delay: 1
    });

    export default {
        name: 'Step3_MobileNum',
        data() {
            return {
                phoneNumber: ''
            }
        },
        watch: {
            phoneNumber: function (val) {
                // console.log(val);
                const data = {
                    field: 'mobile_number',
                    new_value: val
                }
                amplitude.getInstance().logEvent('input_changed', data);
            }
        },
        components: {
            checkWhiteIcon,
            InputField
        },
        computed: {
            numberValid: function () {
                return this.phoneNumber.length == 14
            }
        },
        methods: {

            unmask(val) {
                return val.replace(/\D+/g, '');
            },

            goNextStep() {

                if (!this.numberValid) {
                    return;
                }

                const unmaskedNumber = this.unmask(this.phoneNumber);
                const formattedNumber = '+1' + unmaskedNumber;

                this.$emit('showLoading');

                contactsCollection.push()
                .then(newRef => {

                    const newContactModel = {
                        'country': 'US',
                        'id': newRef.key,
                        'name': this.$parent.currentName,
                        'profileImageUrl': 'https://firebasestorage.googleapis.com/v0/b/ohana-4dd34.appspot.com/o/UserImages%2F88n3CkBsoiXdU8E5LYPi1s1tT6d2%2FprofilePicture?alt=media&token=a32567f2-9e2d-4e93-8ed1-d49a43f01859',
                        'phone': formattedNumber
                    }

                    newRef.set(newContactModel)
                    .then(() => {
                        console.log('new contact created with key:')
                        console.log(newRef.key)

                        // Add contact to user model
                        usersCollection.child(this.$parent.currentUid).child('contacts').child(newRef.key).set('0')
                        .then(() => {
                            console.log('alright updated user contacts model!')
                            this.$emit('dismissLoading');
                            this.$emit('nextStep');
                        })
                        .catch(error => {
                            console.log('error updating the user model contacts:')
                            console.log(error)
                        })
                    })
                    .catch(error => {
                        console.log('error setting contact:')
                        console.log(error);
                    })  
                })
                .catch(error => {
                    console.log('new contact push failed')
                    console.log(error);
                })
            }
        },
        mounted() {

            amplitude.getInstance().logEvent('signup_page_mobilenum_loaded');

            const {title, subtitle, form, button} = this.$refs;
            tl
            .from([title, subtitle], 1.2, {autoAlpha: 0, ease: Power2.easeOut})
            .from(form, 1.2, {autoAlpha: 0, ease: Power2.easeOut}, "-=.8")
            .from(button, 1.2, {scale: .9, autoAlpha: 0, ease: Power2.easeOut}, "-=.8")
        }
    }
</script>




// WEBPACK FOOTER //
// Step3_MobileNum.vue?f23d5fbc